import * as angular from 'angular';

import { ReportsRepo as reportsRepo } from '@services/reports.repo';
import { ClientRepo as clientsRepo } from '@services/clients/client.repo';
import {reports} from '@app/reports/reports';

export const reportsModule = 'reports'

angular
  .module(reportsModule, [])
  .service('clientsRepo', clientsRepo)
  .service('reportsRepo', reportsRepo)
  .component('reports', reports)



// WEBPACK FOOTER //
// ./src/app/reports/reports.index.ts